import useRefinementStore from "@/use-refinement-store";
import turfDistance from "@turf/distance";
import React, { FunctionComponent, useMemo } from "react";
import { AmpolService } from "types";

const Card: FunctionComponent<CardProps> = ({
  onClick,
  service,
  indicated,
  onMouseEnter,
  onMouseLeave,
  onFocus,
  onBlur,
  extended,
}) => {
  const position = useRefinementStore((store) => store.position);

  const distance = useMemo(() => {
    if (position != null) {
      return turfDistance(position, service.position, {
        units: "kilometers",
      });
    }
  }, [position, service]);

  const hasWOWDiscounts = useMemo(
    () => service.services?.includes("WOWDiscounts"),
    [service.services]
  );

  return (
    <div
      className={`${
        indicated === true ? "tw-border-nrma-dark-blue " : "tw-border-white"
      } tw-border-solid tw-border-2 tw-rounded-md tw-bg-white tw-w-full tw-pointer-events-auto tw-cursor-pointer`}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus}
      onBlur={onBlur}
      onTouchEnd={onClick}
    >
      <div className="tw-flex tw-flex-row">
        <div className="tw-flex-fit tw-mr-2">
          <img
            src="https://cdn.alpacamaps.com/nrma/ampol-member-benefits/ampol_logo_color_600w.png"
            className="tw-w-10 tw-m-1 tw-bg-white tw-border tw-p-2 tw-rounded"
            alt="Ampol Logo"
          />
        </div>
        <div className="tw-text-left tw-p-1 tw-w-full tw-flex-grow">
          <h3 className="tw-font-header tw-text-ellipsis">{service.name}</h3>
          <p className="tw-text-xs tw-text-ellipsis">
            {distance != null ? `${distance.toFixed(1)} km, ` : ""}
            {service.addressLineOne}, {service.locality}, {service.region}{" "}
            {service.postalCode}
          </p>

          {extended === true && hasWOWDiscounts === false && (
            <img
              src="//cdn.alpacamaps.com/nrma/ampol-member-benefits/tag-my-nrma-discount.png"
              alt="My NRMA discount"
              className="tw-mt-1"
              width="150"
            />
          )}
          {extended === true && hasWOWDiscounts === true && (
            <>
              <img
                src="//cdn.alpacamaps.com/nrma/ampol-member-benefits/tag-my-nrma-everyday-rewards-discount.png"
                alt="Everyday Rewards discount"
                width="200"
                className="tw-mt-1"
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export type CardProps = {
  service: AmpolService;
  onClick: VoidFunction;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
  onFocus?: React.FocusEventHandler<HTMLDivElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;
  onBlur?: React.FocusEventHandler<HTMLDivElement>;
  indicated?: boolean;
  extended?: boolean;
};

export default React.memo(Card);
